import FaqRow from "./FaqRow";
import { FaqDTO } from "../../../api/FAQs/GetAllFAQ";
const FaqTable = ({ data }: { data?: FaqDTO[] }) => {
    return (
        <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch ">
            <table className="table-auto w-full">
                <thead className="text-lg capitalize ">
                    <tr className="bg-[#F1F4F9] rounded-t-lg">
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                            <div className="text-left text-sm">
                                Question
                            </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                            <div className="text-left text-sm">
                                Answer
                            </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                            <div className="text-left text-sm">
                                Video
                            </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap ">
                            <div className="text-left text-sm sr-only">
                                
                            </div>
                        </th>

                    </tr>
                </thead>
                <tbody className="text-sm">
                    {data?.map((faq: FaqDTO) => (
                        <FaqRow
                            key={faq.id}
                            faqId={faq.id}
                            answer={faq.answer}
                            question={faq.question}
                            video={faq.video}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FaqTable;
